import { fromJS } from 'immutable';
import React, { memo, useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import ReklamaciaForm from './ReklamaciaForm';
import BlockLoader from '@/ui/BlockLoader';
import { accountCustomerId$, accountEmail$, loggedIn$ } from '@/account/subs';
import { ticketDetail$ } from '@/mytickets/detail/subs';

/**
 *  Root path component; params: [hash]
 */
function Reklamacia({ hash }) {
    useEffect(() => {
        dispatch(['ticketus/detail/fetch', [hash]]);
    }, [hash]);

    const { subscribe } = useReframe();
    const userEmail = subscribe(accountEmail$);
    const ticket = subscribe(ticketDetail$(hash));
    const { ticketNumber } = ticket;
    const loggedIn = subscribe(loggedIn$);
    let userId = subscribe(accountCustomerId$);

    //loggedIn este nie je inicializovany
    if (!loggedIn) {
        return null;
    }

    //ticket sa nacitava
    if (!ticket) {
        return <BlockLoader />;
    }

    const initialData = fromJS({ userEmail, userId, hash, ticketNumber });
    return <ReklamaciaForm initialData={initialData} />;
}

export default memo(Reklamacia);
